import React, { Component } from "react";
import PropTypes from 'prop-types';
import {answerBubbleStyle, answerBubbleStyleMobile} from '../../utils/styles';
import Api from '../../utils/api';

class helloavaText extends Component {
  constructor(props) {
    super(props);
    this.fun_handleButtonDom = this.fun_handleButtonDom.bind(this);
    this.fun_handleButtonClick = this.fun_handleButtonClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClassName = this.handleClassName.bind(this);
    this.handleAllSelect = this.handleAllSelect.bind(this);
    this.handleCancelAll = this.handleCancelAll.bind(this);

    this.state = {
        htmlCode: this.props.htmlDom,
        showText: this.props.showText,
        buttonDataArrar: this.props.buttonDataArrar ? this.props.buttonDataArrar:[], 
        selectButtonValue:'',
        selectButtonText:'',
        submitted: false,
        selectButtonValueArray:[],
        selectButtonTextArray:[],
        isAllSelect: this.props.isAllSelect ? this.props.isAllSelect: false,
    }
  }

  componentDidMount(){
    // ReactGA 配合谷歌跟踪
    try {
      let skinQuizType = this.props.skinQuizType;
      if(skinQuizType)
      Api.eventTrackingStageProgress(skinQuizType.replace("SQ_",""));
    } catch (error) {}

     // 最后那十几个（号称闪电轮）的问题的 进度条
     let quizType = this.props.skinQuizType;
     try {
       if(quizType.indexOf("SQ_A8") != -1 ){
         quizType = quizType.replace("SQ_A8-","");
         quizType = parseInt(quizType)+12-1;

         this.props.updateStage(quizType,24);
       }
     } catch (error) {}

     // 进度条
     try {
       if(this.props.fun_updateStage){
         var stage = this.props.stage;
         var stageSum = this.props.stageSum;
         if(stage && stageSum)
         this.props.fun_updateStage(parseInt(stage),stageSum);
       }
     } catch (error) {
       console.error(error);
     }

  }

  fun_handleButtonClick(text,value,type,e){
        e.stopPropagation();
        let selectButtonValueArray=[], selectButtonTextArray=[];

        if(this.state.isAllSelect == false){
          try {
            if(selectButtonValueArray.includes(value)){
                var index = selectButtonValueArray.indexOf(value); 
                if (index > -1) {
                selectButtonTextArray.splice(index, 1);
                selectButtonValueArray.splice(index, 1);
                }
            }else{
                selectButtonValueArray = [];
                selectButtonTextArray = [];
                selectButtonTextArray.push(text);
                selectButtonValueArray.push(value);
            }
            

          } catch (error) {
              console.log(error);
          }
        }else{
            selectButtonValueArray = this.state.selectButtonValueArray;
            selectButtonTextArray = this.state.selectButtonTextArray;

            try {
              if(selectButtonValueArray.includes(value)){
                  var index = selectButtonValueArray.indexOf(value); 
                  if (index > -1) {
                    selectButtonTextArray.splice(index, 1);
                    selectButtonValueArray.splice(index, 1);
                  }
              }else{

                if(type == "cancelAll"){
                  selectButtonValueArray = [];
                  selectButtonTextArray = [];
                }else{
                  this.handleCancelAll()
                }

                  selectButtonTextArray.push(text);
                  selectButtonValueArray.push(value);
              }
            } catch (error) {
                console.log(error);
            }
        }
       
        this.setState({
            selectButtonValueArray: selectButtonValueArray,
            selectButtonTextArray: selectButtonTextArray,
        },()=>{
          if(this.state.isAllSelect == false){
             this.handleSubmit();
          }
        });
  }

  handleCancelAll(){

    let buttonDataArrar = this.props.buttonDataArrar;
    let cancelAllArrayData = [];
    buttonDataArrar.forEach(element => {
      if(element['type'] == 'cancelAll'){
        cancelAllArrayData = element;
      }
    });
    

    let selectButtonValueArray = this.state.selectButtonValueArray;
    let selectButtonTextArray = this.state.selectButtonTextArray;

    if(cancelAllArrayData){
      if(selectButtonValueArray.includes(cancelAllArrayData.value)){
        var index = selectButtonValueArray.indexOf(cancelAllArrayData.value); 
        if (index > -1) {
          selectButtonTextArray.splice(index, 1);
          selectButtonValueArray.splice(index, 1);
        }
      }
    }
    
    this.setState({
      selectButtonValueArray: selectButtonValueArray,
      selectButtonTextArray: selectButtonTextArray,
    });

 
  }




  handleClassName(target){
    let bubbleClassName = "onb-but";
    let selectButtonValueArray = this.state.selectButtonValueArray;
    if(selectButtonValueArray.includes(target)){
      bubbleClassName = "onb-but onb_action";
    }
    return bubbleClassName;
  }

  handleAllSelect(){
    let allSelectData = this.state.buttonDataArrar;
    let selectButtonValueArray = [], selectButtonTextArray = [];
    allSelectData.forEach(element => {
        selectButtonTextArray.push(element['text']);
        selectButtonValueArray.push(element['value']);
    });

    this.setState({
        selectButtonValueArray: selectButtonValueArray,
        selectButtonTextArray: selectButtonTextArray,
    });

  }

  

  fun_handleButtonDom(){
    let buttonHtml = '';
    buttonHtml = this.state.buttonDataArrar.map((data,index) =>{
      return(
        <button key={index} onClick={(e)=>{this.fun_handleButtonClick( data.label,data.value,data.type, e )}} name="selectButtonValue"  className={this.handleClassName(data.value)}>{data.label}</button>
      )
    })
    if(buttonHtml == ''){
      return null;
    }else{
      // 谷歌追踪针对个别问题加上不同的class，用以区别
      let gtmClass = '';
      if(this.props.skinQuizType == 'SQ_A8-11'){
        gtmClass = ' onb-but-container-airpollutionquestion';
      }else if(this.props.skinQuizType == 'SQ_A8-6'){
        gtmClass = ' onb-but-container-acnequestion';
      }
      return ( <div className="conten-wrap"> <div style={this.state.isAllSelect == false?{display:'none'}:{display:'block'} } className="onb-se-allBut">Select all that apply</div> 
                  <div className={"onb-but-container"+gtmClass} > {buttonHtml}</div> 
                  <button className="p-a-n-button" style={this.state.isAllSelect == false?{display:'none'}:{display:'block'} } onClick={this.handleSubmit}>Continue</button>
              </div>  );
    }
    
  }

  handleSubmit(){
    if(this.state.selectButtonValueArray.length > 0 ){
      this.setState({ submitted: true });
      if(this.props.skinQuizType){
        localStorage.setItem(this.props.skinQuizType, this.state.selectButtonValueArray.join());
      }

     
      
      this.props.step.value = {value:this.state.selectButtonValueArray.join() ,label:this.state.selectButtonTextArray.join(", ")};
      this.props.triggerNextStep({
        value: {value:this.state.selectButtonValueArray.join() ,label:this.state.selectButtonTextArray.join(", ")},
      });
    }else{
      alert("Please select an answer.");
    }
  }

  render() {
    if (this.state.submitted) {
      return (
      <div className="onb-item-container">
        <div className="onb-text-conten">{this.state.showText}</div>
      </div>
      );
    }
    return (
            // <div dangerouslySetInnerHTML={{__html:this.state.htmlCode}}></div>
            <div className="onb-item-container">
              <div className="onb-text-conten">
                {this.state.showText}   
                {
                  this.props.helloTextStorageKey ?" "+localStorage.getItem( this.props.helloTextStorageKey ) :null
                }{ this.props.helloTextStorageKey == "SQ_firstname" ? "!":null  }
              </div>
              {
                this.state.htmlCode ? <div style={{marginTop:0}} dangerouslySetInnerHTML={{__html:this.state.htmlCode}}></div> : null
              }
              
              {this.fun_handleButtonDom()}
            </div>
    );
  }
}

helloavaText.propTypes = {
  steps: PropTypes.object,
};

helloavaText.defaultProps = {
  steps: undefined,
};

export default helloavaText;



// WEBPACK FOOTER //
// ./src/views/onboarding/helloavaText.js